import { proformaIssueFormsDirectEntryPoint } from '@atlassian/jira-spa-apps-proforma-issue-forms-direct/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';

export const proformaIssueFormsDirectPageEntryPoint = createPageEntryPoint({
	main: proformaIssueFormsDirectEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
